import { create } from "zustand";

type ModalState = {
  getInTouchHandledForms: Set<string>;
  hasHandledGetInTouch: (formId: string) => boolean;
  markGetInTouchHandled: (formId: string) => void;
  resetGetInTouchHandled: (formId: string) => void;
};

export const useModalStateStore = create<ModalState>((set, get) => ({
  getInTouchHandledForms: new Set(),

  hasHandledGetInTouch: (formId): boolean =>
    get().getInTouchHandledForms.has(formId),

  markGetInTouchHandled: (formId): void =>
    set((state) => {
      const next = new Set(state.getInTouchHandledForms);

      next.add(formId);

      return { getInTouchHandledForms: next };
    }),

  resetGetInTouchHandled: (formId): void =>
    set((state) => {
      const next = new Set(state.getInTouchHandledForms);

      next.delete(formId);

      return { getInTouchHandledForms: next };
    }),
}));
